"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const styles_1 = require("@material-ui/core/styles");
const core_1 = require("@material-ui/core");
const icons_1 = require("@material-ui/icons");
const components_1 = require("@alcumus/components");
const useStyles = (0, styles_1.makeStyles)((theme) => (0, styles_1.createStyles)({
    root: {
        width: 226,
        height: theme.spacing(10),
        borderRadius: theme.spacing(1),
    },
    pos: {
        color: components_1.StyleVariables.colors.grey4,
        lineHeight: '18px',
        wrap: 'nowrap',
    },
    details: {
        display: 'flex',
        flexDirection: 'column',
    },
    container: {
        justifyContent: 'center',
    },
    cardContent: {
        padding: `${theme.spacing(2)}px 0 0 ${theme.spacing(1)}px`,
        flexWrap: 'nowrap',
    },
    verticallyCenter: {
        lineHeight: '50px',
    },
}));
const FolderTile = ({ data, headers }) => {
    const classes = useStyles();
    const includeDashboard = headers?.includes('Dashboards');
    const includeLooks = headers?.includes('Looks');
    return (react_1.default.createElement(react_router_dom_1.NavLink, { to: `${data.basePath}` },
        react_1.default.createElement(core_1.Card, { className: classes.root, variant: "outlined" },
            react_1.default.createElement(core_1.Grid, { container: true, className: classes.container, wrap: "nowrap" },
                react_1.default.createElement(core_1.Grid, { item: true, xs: 2 },
                    react_1.default.createElement(core_1.Box, { m: 2, display: "flex", alignItems: "center", flexDirection: "column" },
                        react_1.default.createElement(core_1.CardContent, null,
                            react_1.default.createElement(icons_1.FolderOutlined, { style: { color: components_1.StyleVariables.colors.grey4 } })))),
                react_1.default.createElement(core_1.Grid, { item: true, xs: 9 },
                    react_1.default.createElement(core_1.CardContent, { className: classes.cardContent },
                        react_1.default.createElement(components_1.Text, { noWrap: true, className: !(!!includeDashboard && !!includeLooks)
                                ? classes.verticallyCenter
                                : undefined }, data.name),
                        !!includeDashboard && !!includeLooks && (react_1.default.createElement(components_1.Text, { as: "span", className: classes.pos, noWrap: true },
                            data.dashboards || 0,
                            " Dashboards, ",
                            data.looks || 0,
                            " Looks"))))))));
};
exports.default = FolderTile;
